import React from "react";
import { useParams, Navigate } from "react-router-dom";

import { useAdDetail, useMetadata } from "hooks/query";
import { NotFoundError } from "components/ErrorBoundary";
import NotFound from "routes/NotFound";

export default function RedirectAddSectionAdd() {
    const { slug } = useParams();

    const metadataQuery = useMetadata();
    const adDetailQuery = useAdDetail(slug);

    if (adDetailQuery.isSuccess && metadataQuery.isSuccess) {
        let section = metadataQuery.data.sections.$values.find((value) => {
            console.log(adDetailQuery.data.sectionEnum, adDetailQuery.data)
            return parseInt(value.extra) === adDetailQuery.data.sectionEnum;
        });
        
        if (section?.key) {
            return <Navigate to={`/${section.key}/utbildning/${slug}`} />;
        } else {
            return <NotFound/>
        }
    }
    return false;
}
